(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-block"] && !window.DesignMode) return;
  try {
    
(function(){
    var _add_to_cart = jQuery('.js-atc-form');

    _add_to_cart.submit(function() {
        $('#add-to-cart-error').html('');
        jQuery('.cart-button').prop('disabled', true);
        jQuery('.cart-button .btn-progress').animate({
            width: '30%'
        }, 250);

        $('#add-to-cart-error').empty().hide()

        VastaShop.Cart.addItem(jQuery(this).serialize()).then(function(prod, status) {
            if ('success' == status) {
                VastaShop.Cart.getAllItems().then(function(cart, status) {
                    if ('success' === status) {
                        jQuery('.btn-add-tocart .btn-progress').animate({
                            width: '100%'
                        }, 250, function() {
                            jQuery(this).css('width', '0').show();
                        });

                        VastaShop.Cart.current = cart;

                        jQuery('.cupom-text').show();
                        render_cart_drawer(VastaShop.Cart.current, jQuery('.list-products'), 0, '');

                        update_shipping_bar(cart.total_price, cart.item_count);

                        jQuery('.cart-button').prop('disabled', false);
                        jQuery('body').addClass('cart-drawer-open cart-open');
                        inventoryControl(prod.id);
                    }
                }).catch(function(err) {
                    console.log(err);
                });
            }
        }).catch(function(err) {
            jQuery('.cart-button').prop('disabled', false).hide();

            if (err.status === 422) {
                $('#add-to-cart-error').html('Maximum Quantity Allowed').show();
            } else {
                throw err;
            }
        });

        return false;
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pages-shipping_bar"]) return;
  try {
    
  window.SectionShippingBar = (function () {
    function SectionShippingBar() {
      this._run();
    }

    SectionShippingBar.prototype = {
      _run: function () {
        if (typeof update_shipping_bar === 'function') {
          update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);
        }
      },

      onSelect: function () {
        this._run();
      },

      onUnload: function () {},
    };

    return new SectionShippingBar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shipping_bar"]) return;
  try {
    
    window.SectionShippingBar = (function(){
        function SectionShippingBar() {
            this._run();
        }

        SectionShippingBar.prototype = {
            _run: function() {
                update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);
            },

            onSelect: function() {
                this._run();
            },

            onUnload: function() {

            }
        };

        return new SectionShippingBar;
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
window.SectionFooter = (function(){
  function SectionFooter() {
    this._run();
  }

  SectionFooter.prototype = {
    _run: function() {

      if ( window.innerWidth < 768 )
        $('.site-footer .menu-footer-grid').addClass('clickable');
      else
		    $('.site-footer .menu-footer-grid').removeClass('clickable');

		$(window).resize(function(){
      if ( window.innerWidth < 768 ) {
        $('.site-footer .menu-footer-grid').addClass('clickable');
        $('.site-footer .menu-footer-grid .no-bullets').hide();
      } else {
        $('.site-footer .menu-footer-grid').removeClass('clickable');
        $('.site-footer .menu-footer-grid .no-bullets').show();
		  }
		});

		$('.site-footer .menu-footer-grid').click(function(){
		  	if (window.innerWidth < 768 && $(this).hasClass('clickable')) {

          $('.site-footer .menu-footer-grid .no-bullets').stop().slideUp();

          if ($('.no-bullets', this).is(':visible')){
            $('.no-bullets', this).stop().slideUp();
            $('.nav-title', this).removeClass('row-rotate');
          }else {
            $('.nav-title', this).addClass('row-rotate');
            $('.no-bullets', this).stop().slideDown();
            $(this).siblings().children('.nav-title').removeClass('row-rotate');
        }
      }
      });
    },

    onLoad: function() {
      this._run();
    },

    onUnload: function() {

    }
  };

  return new SectionFooter;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["level-up-videos"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('DOMContentLoaded', function(){
        try {
            /* Modal */
            const linkList = document.querySelectorAll('.level-up-video__link');
            const closeModal = document.querySelectorAll('.modal__overlay,.modal__box-close');

            linkList.forEach(function(link){
                link.addEventListener('click', function(event){
                    event.preventDefault();

                    const modal = document.getElementById(link.dataset.modal);

                    if (modal) {
                        const iframe = modal.querySelector('iframe');

                        if (iframe) {
                            document.body.classList.add('level-up-video__modal--active');

                            iframe.src = this.href;
                        }
                    }
                })
            });

            closeModal.forEach(function(elemClose) {
                elemClose.addEventListener('click', function(event){
                    event.preventDefault();

                    const modal = this.closest('.modal');

                    if (modal) {
                        const iframe = modal.querySelector('iframe');

                        if (iframe) {
                            document.body.classList.remove('level-up-video__modal--active');

                            iframe.src = '';
                        }
                    }
                });
            });
        } catch(err) {
            console.error('[LEVEL UP VIDEOS]', err);
        }
    });

    window.addEventListener('load', function(){
        try {
            /* jQuery */
            (function(){
                const $window = $(window);
                const $document = $(document);

                /* Slick*/
                const $videosSlider = $('.level-up-videos__slider');

                if (typeof $videosSlider.slick === 'function') {
                    if ($window.width() < 768) {
                        $videosSlider.slick({
                            slidesToShow: 1,
                            prevArrow: '<button type="button" class="slick__arrow slick__arrow--prev">&lang;</button>',
				            nextArrow: '<button type="button" class="slick__arrow slick__arrow--next">&rang;</button>',
                            dots: true
                        });
                    } else {
                        if ($videosSlider.length > 0) {
                            $videosSlider.slick('unslick');
                        }
                    }
                }
            })($);
        } catch(err) {
            console.error('[LEVEL UP VIDEOS]', err);
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["members-area-mobile-menu"]) return;
  try {
    
  $(document).on('click', '.jq-icon-fallback-text', function(){
    if($('body').hasClass('js-drawer-open-left'))
      $('body').removeClass('js-drawer-open-left');
    else {
      $('.main-content').addClass('is-moved-by-drawer');
      $('.fixed').addClass('is-moved-by-drawer');
      $('.shopify-section header').addClass('is-moved-by-drawer');
      $('.search').addClass('is-moved-by-drawer');
      $('body').addClass('js-drawer-open-left');
    }
  });
  
  $(document).on('click', '.DrawerOverlay', function(){
    $('body').removeClass('js-drawer-open-left cart-open cart-drawer-open');
  });
  
  $(document).on('click', '.mobile-nav__toggle-open,.mobile-nav__link[href^="#"]', function(){
    var instance = $(this);
  
    instance.parent().siblings('.child').slideToggle(400);
  
    if (instance.is('.mobile-nav__link')) {
      instance = instance.siblings('.mobile-nav__toggle-open');;
    }
  
    if( instance.hasClass('anime-plus-ver') ) {
      instance.removeClass('anime-plus-ver anime-plus-hor');
    } else {
      instance.addClass('anime-plus-ver anime-plus-hor');  
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-mobile"]) return;
  try {
    
$(document).on('click', '.jq-icon-fallback-text', function(){
  if($('body').hasClass('js-drawer-open-left'))
    $('body').removeClass('js-drawer-open-left');
  else {
    $('.main-content').addClass('is-moved-by-drawer');
    $('.fixed').addClass('is-moved-by-drawer');
    $('.shopify-section header').addClass('is-moved-by-drawer');
    $('.search').addClass('is-moved-by-drawer');
    $('body').addClass('js-drawer-open-left');
  }
});

$(document).on('click', '.DrawerOverlay', function(){
  $('body').removeClass('js-drawer-open-left cart-open cart-drawer-open');
});

$(document).on('click', '.mobile-nav__toggle-open,.mobile-nav__link[href^="#"]', function(){
  var instance = $(this);

  instance.parent().siblings('.child').slideToggle(400);

  if (instance.is('.mobile-nav__link')) {
    instance = instance.siblings('.mobile-nav__toggle-open');;
  }

  if( instance.hasClass('anime-plus-ver') ) {
    instance.removeClass('anime-plus-ver anime-plus-hor');
  } else {
    instance.addClass('anime-plus-ver anime-plus-hor');  
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-menu-mobile"]) return;
  try {
    
$(document).on('click', '.jq-icon-fallback-text', function(){ 
  if($('body').hasClass('js-drawer-open-left'))
    $('body').removeClass('js-drawer-open-left');
  else {
    $('.main-content').addClass('is-moved-by-drawer');
    $('.fixed').addClass('is-moved-by-drawer');
    $('.shopify-section header').addClass('is-moved-by-drawer');
    $('.search').addClass('is-moved-by-drawer');
    $('body').addClass('js-drawer-open-left');
  }
});

$(document).on('click', '.DrawerOverlay', function(){
  $('body').removeClass('js-drawer-open-left cart-open cart-drawer-open');
});

$(document).on('click', '.mobile-nav__toggle-open,.mobile-nav__link[href^="#"]', function(){
  var instance = $(this);

  instance.parent().siblings('.child').slideToggle(400);

  if (instance.is('.mobile-nav__link')) {
    instance = instance.siblings('.mobile-nav__toggle-open');;
  }

  if( instance.hasClass('anime-plus-ver') ) {
    instance.removeClass('anime-plus-ver anime-plus-hor');
  } else {
    instance.addClass('anime-plus-ver anime-plus-hor');  
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !window.DesignMode) return;
  try {
    
window.SectionReviews = (function(){
  function SectionReviews() {
    this.settings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1019,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionReviews.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed,
          settings = this.settings;

      jQuery('[id^="slider-reviews-"]').each(function(){
        slider = '#slider-' + $(this).data('slider');

        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;

        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionReviews;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping_bar"]) return;
  try {
    
    window.SectionShippingBar = (function(){
        function SectionShippingBar() {
            this._run();
        }

        SectionShippingBar.prototype = {
            _run: function() {
                update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);
            },

            onSelect: function() {
                this._run();
            },

            onUnload: function() {

            }
        };

        return new SectionShippingBar;
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-promotional"] && !window.DesignMode) return;
  try {
    
window.SectionSliderPromotional = (function(){
  function SectionSliderPromotional() {
    this.settings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      arrows: true,
      responsive: [
          {
              breakpoint: 1180,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 1019,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionSliderPromotional.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed, settings = this.settings;

      jQuery('[id^="slider-promotional-"]').each(function(){
        slider = '#promotional-' + $(this).data('slider');
        
        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;
        
        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionSliderPromotional;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !window.DesignMode) return;
  try {
    

window.SectionVideoSlider = (function(){
    function SectionVideoSlider() {
      this._run();
    }

    SectionVideoSlider.prototype = {
      onSelect: function() {
        this._run();
      },

      _run: function() {
        $('.dynamic-video__slider-container').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
          nextArrow: '<button type="button" class="slick-next">&rang;</button>',
          infinite: true
        });
      }
    };

    return new SectionVideoSlider;
})();


  } catch(e) { console.error(e); }
})();
})();
